import * as z from "zod/v4";

export const sendGmailPromotionTabWhitelistRequest = {
  name: "sendGmailPromotionTabWhitelistRequest" as const,
  input: z.object({ domain: z.string(), teamId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
